import {css, styled} from 'styled-components'
import {ModalOverlay, Modal} from '@components/ui/modal-atoms/ModalAtoms.tsx'

export const StyledDeleteConversationModalOverlay = styled(ModalOverlay)(
    ({theme: {zIndex}}) => css`
        z-index: ${zIndex.modal + 1};
    `
)

export const StyledDeleteConversationModal = styled(Modal)(
    ({theme: {zIndex}}) => css`
        z-index: ${zIndex.modal + 2};
    `
)
